// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var Location = function Location(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.625 7.5A5.626 5.626 0 0 0 10 1.875 5.626 5.626 0 0 0 4.375 7.5c0 .484.176 1.234.598 2.234.41.97.992 2.04 1.66 3.121 1.113 1.805 2.402 3.547 3.367 4.79.969-1.243 2.258-2.985 3.367-4.79.668-1.082 1.25-2.152 1.66-3.12.422-1 .598-1.75.598-2.235m1.875 0c0 3.414-4.57 9.492-6.574 12a1.18 1.18 0 0 1-1.852 0C7.07 16.992 2.5 10.914 2.5 7.5 2.5 3.36 5.86 0 10 0s7.5 3.36 7.5 7.5m-6.25 0a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0m-4.375 0a3.125 3.125 0 1 1 6.25 0 3.125 3.125 0 0 1-6.25 0"
  }));
};
